import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { NavigationService } from '@app/shared/common/navigation/navigation.service';
import { OAuthServiceService } from '@app/shared/common/services/Authentication/oauth-service.service';
import { SettingsService } from '@app/shared/common/services/Authentication/settings.service';
import { CommonMethodsService } from '@app/shared/common/services/common-methods.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone:false
})
export class LoginComponent implements OnInit {
  public isLoggedInUser: boolean = false;
  public readonly isBaseApplication = environment.isBaseApplication;
  // public isEycLogin: boolean = AppConst.EYC_LOGIN;
  public showToasterIfUserSessionExtent: boolean = false;

  constructor(
    private navigation: NavigationService,
    private oauthSvc: OAuthServiceService,
    private oauthService: OAuthService,
    private activatedRoute: ActivatedRoute,
    private settingService: SettingsService,
    private commonService: CommonMethodsService
  ) {
    this.isLoggedInUser = this.settingService.isUserLoggedin();
  }

  ngOnInit(): void {
    if (
      sessionStorage.getItem('navigateToLogin') &&
      sessionStorage.getItem('navigateToLogin') !== undefined
    ) {
      this.showToasterIfUserSessionExtent = true;
      sessionStorage.removeItem('navigateToLogin');
    }
    if (this.isLoggedInUser && this.commonService.getIsUserDetailsLoaded() && environment.isBaseApplication) {
      this.navigation.navigateTo(this.navigation.getRegionSelectionRoute);
    }
    else if (this.isLoggedInUser && this.commonService.getIsUserDetailsLoaded() && this.commonService.getPrivacyAccepted()) {
      this.navigation.navigateTo(this.navigation.getDtFundListingRoute);
    }
    else if(this.isLoggedInUser && this.commonService.getIsUserDetailsLoaded() && !this.commonService.getPrivacyAccepted()){
      this.navigation.navigateTo(this.navigation.getPrivacyNoticeUrl);
    }
    
    // if (this.isEycLogin) {
    //   this.eycWebApplogin();
    // }
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['logout'] === 'true') {
        this.isLoggedInUser = false;
      }
    });
  }

  routeToHome() {
    // if (!this.isEycLogin) {
    this.eycWebApplogin();
    // }
  }

  eycWebApplogin() {
    if (!this.oauthService.getAccessToken()) {
      this.oauthSvc.login();
    } else {
      this.navigation.navigateTo(this.navigation.getHomePageUrl);
    }
  }
}
